export const SITE_CONFIG = {
    name: "Yurii Suprun",
    githubUsername: "yuriisuprun",
    email: "iursuprun@gmail.com",
    phone: "+380984211558",
    github: "https://github.com/yuriisuprun",
    linkedin: "https://www.linkedin.com/in/yurii-suprun/",
    instagram: "https://www.instagram.com/yuriidigitalpartner.milan/",
    piva: "13728820963" // P.IVA (Partita IVA) - Italian VAT number
};